<template>
  <div>
    <Top class="top"/>
    <div class="l-container">
      <div class="inner">
        <div class="col_menu">
          <div class="col_menu_head">
            <h3 class="col_menu_text">集团概况</h3>
          </div>
        </div>
        <div class="col_news">
          <div class="col_news_box">
            <div class="col_news_head">
              <div class="col_path">
                <span>当前位置：<span style="color: #0c4da2;">首页｜集团概况</span></span>
              </div>
            </div>
            <div class="col_news_con">
              <div class="col_news_list listcon">
                扬州绿色产业投资发展控股（集团）有限责任公司成立于2010-03-12，法定代表人为丁斌，注册资本为900000万元人民币，统一社会信用代码为913210005512387369，企业地址位于扬州市江阳中路433号，所属行业为商务服务业，经营范围包含：基础设施建设；建筑工程、市政工程、园林绿化工程、房屋工程建筑安装施工，钢结构安装；建设工程监理，工程咨询，技术开发，工程项目管理；土地整理；商品销售（需要行政许可或限定企业经营的除外），科技研发服务，信息咨询服务；水利水电工程施工、工程维修与养护、施工设备租赁；排水技术咨询；自动化设备、仪器仪表、电线电缆的销售；给排水设施销售、维护；节能工程方案设计、施工、技术咨询；水表设计检测；河道疏浚；金属结构安装与销售。（依法须经批准的项目，经相关部门批准后方可开展经营活动）。扬州绿色产业投资发展控股（集团）有限责任公司目前的经营状态为在业。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterHtm style="margin-top: 10px"/>
  </div>
</template>

<script>
import Top from './Top'
import $http  from '../ApI/request'  //$http是在导入时自定义的命名可变的
import FooterHtm from './FooterHtm'
export default {
  name: 'Survey',
  components:{
    Top,
    FooterHtm
  },
  data(){
    let jd = localStorage.getItem('jdjd');
    if (jd) {
      // console.log("1")
      if (this.$route.params.num) {
        localStorage.setItem('jdjd', this.$route.params.num);
      }
    } else {
      // console.log("2")
      localStorage.setItem('jdjd',this.$route.params.num)
    }
    return{
      num:localStorage.getItem('jdjd'),
      id:'',
      ids:''
    }
  },
  mounted() {
    console.log(this.$route.params.num)
    console.log(this.num)
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'机构设置',
      }
    }).then(res=>{
      console.log(res)
      if (res){
        this.id = res.data.result.records[0].id
      }
    }).catch(e=>{
      console.log(e)
    });
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'荣誉资质',
      }
    }).then(res=>{
      console.log(res)
      if (res){
        this.ids = res.data.result.records[0].id
      }
    }).catch(e=>{
      console.log(e)
    });
  },
  methods:{
    jump(){
      this.$router.push({
        name:'HelloWorld',
      })
    },
    jumpS(){
      console.log(111)
      this.$router.push({
        name:'Survey',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('jdjd')
    },
    jumpT(){
      this.$router.push({
        name:'State',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('stjd')
    },
    jumpF(){
      this.$router.push({
        name:'Party',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('pajd')
    },
    jumpFI(){
      this.$router.push({
        name:'Culture',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('cujd')
    },
    jumpSI(){
      this.$router.push({
        name:'Relation',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('rejd')
    },
    // tabs(){
    //   trs[i].onmouseover = function() {
    //     this.className = "bg"
    //   }
    //   this.className = "second"
    // }
    // skip(){
    //   console.log(111)
    //   this.$router.push({
    //     name:'Party',
    //   })
    // }
  }
}
</script>

<style scoped>
  a{
    color: #000;
    text-decoration: none;
    outline: medium none;
  }
  .l-container {
    width: 100%;
    min-height: 760px;
    margin: 0 auto;
    background: linear-gradient(rgba(12, 77, 162, 0.02), rgba(12, 77, 162, 0.05));
    padding: 40px 0;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .inner {
    padding: 0 20px;
    width: 100%;
    max-width: 1300px;
    margin: 0 auto;
    display: flex;
    gap: 60px;
    box-sizing: border-box;
  }

  .col_menu {
    width: 280px;
    flex-shrink: 0;
  }

  .col_menu_head {
    background: linear-gradient(to right, #0a3d82, #1e5dbd);
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(12, 77, 162, 0.2);
    transition: all 0.3s ease;
  }

  .col_menu_head:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(12, 77, 162, 0.3);
  }

  .col_menu_text {
    font-size: 24px;
    color: #fff;
    display: block;
    line-height: 60px;
    text-align: center;
    font-weight: bold;
    letter-spacing: 2px;
  }

  .col_news {
    flex: 1;
    min-height: 500px;
  }

  .col_news_box {
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  .col_news_head {
    height: 48px;
    border-bottom: 1px solid rgba(12, 77, 162, 0.2);
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .col_path {
    color: #666;
    font-size: 16px;
    font-family: "Microsoft YaHei";
  }

  .col_path span span {
    color: #0c4da2;
  }

  .col_title {
    margin: 0;
  }

  .col_title h2 {
    font-size: 26px;
    font-family: "Microsoft YaHei";
    font-weight: bold;
    color: #0c4da2;
    border-bottom: 4px solid #1e5dbd;
    margin: 0;
    padding-bottom: 10px;
    position: relative;
  }

  .col_title h2::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 40%;
    height: 4px;
    background: #76b6ff;
  }

  .col_news_con {
    padding: 20px 0;
  }

  .col_news_list {
    font-size: 16px;
    line-height: 2;
    color: #333;
    text-indent: 2em;
    font-family: "Microsoft YaHei";
    text-align: justify;
    letter-spacing: 0.5px;
  }

  @media screen and (max-width: 1400px) {
    .inner {
      max-width: 95%;
    }
  }

  @media screen and (max-width: 992px) {
    .inner {
      gap: 30px;
    }
    
    .col_menu {
      width: 240px;
    }
    
    .col_news_box {
      padding: 25px;
    }
  }

  @media screen and (max-width: 750px) {
    .l-container {
      padding: 20px 0;
      min-height: 500px;
    }
    
    .inner {
      width: 100%;
      max-width: 100%;
      padding: 0 15px;
      flex-direction: column;
      gap: 20px;
    }

    .col_menu {
      width: 100%;
    }

    .col_news_box {
      padding: 15px;
    }

    .col_title h2 {
      font-size: 20px;
    }

    .col_path {
      font-size: 14px;
    }

    .col_news_list {
      font-size: 14px;
      line-height: 1.8;
    }
  }

  @media screen and (max-width: 576px) {
    .l-container {
      padding: 15px 0;
    }
    
    .inner {
      padding: 0 12px;
    }
    
    .col_menu_text {
      font-size: 20px;
      line-height: 50px;
    }
    
    .col_news_box {
      padding: 12px;
      border-radius: 6px;
    }
    
    .col_news_head {
      margin-bottom: 20px;
    }
    
    .col_news_list {
      font-size: 14px;
      line-height: 1.7;
      text-indent: 1.5em;
    }
    
    body, html {
      width: 100%;
      max-width: 100%;
      overflow-x: hidden;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Survey.vue